import { t } from "i18next";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { IAllStates } from "../../../store/rootReducer";
import workflowSlice from "../../../store/workflow/workflowSlice";
import { WorkflowService } from "../service";
import Select, { SingleValue } from "react-select";
import { handleStepNavigate } from "./WorkflowStep2";
import { ProfileDetailsService } from "../../profile/service";
import authSlice from "../../../store/auth/authRedux";
import { nanoid } from "nanoid";
import { themeSelect } from "../../../shared/components/Select2";
import { getCorrectFormality } from "../../../shared/functions/Functions";
import { ModalTranslateAll } from "../../../shared/components/ModalTranslateAll";

const perPageOptions = [
  {
    label: 10,
    value: 10,
  },
  {
    label: 50,
    value: 50,
  },
  {
    label: 100,
    value: 100,
  },
  {
    label: 500,
    value: 500,
  },
];

export const WorkflowStepper = ({
  setTriggerUpdate,
  funcForFirstLoading,
  pagination,
  isDisabledComplete = true,
  precent,
  step,
  id,
  setSelectedProductId,
  changeFilterHandler,
  status,
  assigned,
  showMarkAsComplete = true,
  showNextButton = false,
  showFilters = true,
  handlePerPage,
  handleFilterCopywritingStatus,
  stepPagination,
  handleFilterUser,
  userList,
}: any) => {
  const { accessRights, roles } = useSelector(
    (state: IAllStates) => state.auth
  );
  const userClientDashboard = accessRights?.includes(
    "client_dashboard_can_view"
  );
  const [formality, setFormality] = useState(null);
  const isManager = roles?.includes("ROLE_MANAGER");
  const isAdmin = roles?.includes("ROLE_ADMIN");
  const isCompanyAdmin = roles?.includes("ROLE_COMPANY_ADMIN");
  const [arrowArray, setArrowArray] = useState<string[]>([]);
  const { deeplFormality } = useSelector((state: IAllStates) => state.enums);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showTranslateDialog, setShowTranslateDialog] = useState(false);
  const location = useLocation();
  const lightOrDarkMode = useSelector(
    (state: IAllStates) => state.lightOrDarkMode
  );
  const { productId } = useParams();
  const copywritingStatusOptions = [
    {
      label: `${t("global.all")}`,
      value: null,
    },
    {
      label: `${t("global.finished")}`,
      value: "finished",
    },
    {
      label: `${t("global.unfinished")}`,
      value: "unfinished",
    },
  ];
  const { workflowStatus } = useSelector((state: IAllStates) => state.enums);
  const { baseData, attributes } = useSelector(
    (state: IAllStates) => state.workflow
  );
  const [tabsList, setTabsList] = useState([]);
  function handleSelectSingleFormality(
    selectedSingle: SingleValue<{ label: string; value: string }>
  ) {
    setFormality(selectedSingle?.value as any);
  }
  const translateAll = () => {
    setIsLoading(true);
    WorkflowService.workflowTranslateAll(Number(id), {
      formality: formality,
    })
      .then((response) => {
        SuccessToast(`${t("toasts.successfully_translated")}`);
        setTriggerUpdate((prev: boolean) => !prev);
      })
      .catch((error) => {
        ErrorToast(error);
      })
      .finally(() => setIsLoading(false));
  };
  const handleNextProduct = () => {
    if (step === "BASE_DATA") {
      WorkflowService.getNextBaseDataWorkflow(Number(id))
        .then((response) => {
          if (!response.nextProduct?.id) {
            return navigate(`/app/workflow/step3/${id}`);
          } else {
            return navigate(
              `/app/workflow/step3/${response.nextProduct?.id}/${id}`
            );
          }
        })
        .catch((error) => ErrorToast(error));
    } else if (step === "ATTRIBUTES") {
      WorkflowService.getNextAttributesWorkflow(Number(id), step as string)
        .then((response) => {
          if (!response.nextProduct?.id) {
            return navigate(`/app/workflow/step4/${id}`);
          } else {
            return navigate(
              `/app/workflow/step4/${response.nextProduct?.id}/${id}`
            );
          }
        })
        .catch((error) => ErrorToast(error));
    } else if (step === "COPY_WRITING") {
      WorkflowService.getNextAttributesWorkflow(Number(id), step as string)
        .then((response) => {
          if (!response.nextProduct?.id) {
            return navigate(`/app/workflow/step5/${id}`);
          } else {
            return navigate(
              `/app/workflow/step5/${response.nextProduct?.id}/${id}`
            );
          }
        })
        .catch((error) => ErrorToast(error));
    } else {
      return;
    }
  };

  const handleMarkAsComplete = () => {
    if (step === "BASE_DATA") {
      WorkflowService.saveWorkflowBaseDataById(Number(id))
        .then((response) => {
          handleStepNavigate(response?.status, Number(id), navigate);
        })
        .catch((error) => ErrorToast(error));
    } else if (step === "ATTRIBUTES") {
      WorkflowService.saveWorkflowAttributesById(Number(id))
        .then((response) => {
          handleStepNavigate(response?.status, Number(id), navigate);
        })
        .catch((error) => ErrorToast(error));
    } else if (step === "MEDIA") {
      WorkflowService.saveWorkflowMediaById(Number(id))
        .then((response) => {
          handleStepNavigate(response?.status, Number(id), navigate);
        })
        .catch((error) => ErrorToast(error));
    } else if (step === "COPY_WRITING") {
      WorkflowService.saveWorkflowCopywritingById(Number(id))
        .then((response) => {
          handleStepNavigate(response?.status, Number(id), navigate);
        })
        .catch((error) => ErrorToast(error));
    } else if (step === "TRANSLATION") {
      WorkflowService.saveWorkflowTranslationById(Number(id))
        .then((response) => {
          handleStepNavigate(response?.status, Number(id), navigate);
        })
        .catch((error) => ErrorToast(error));
    } else {
      return;
    }
  };
  const handleStepSteper = (status: string, id: number) => {
    switch (status) {
      case "SETTING_UP":
        return `/app/workflow/step1/${id}`;
      case "IMPORT":
        return `/app/workflow/step2/${id}`;
      case "BASE_DATA":
        return `/app/workflow/step3/${id}`;
      case "ATTRIBUTES":
        return `/app/workflow/step4/${id}`;
      case "MEDIA":
        return `/app/workflow/step-media/${id}`;
      case "COPY_WRITING":
        return `/app/workflow/step5/${id}`;
      case "TRANSLATION":
        return `/app/workflow/step6/${id}`;
      case "PREVIEW":
        return `/app/workflow/step9/${id}`;
      case "OVERVIEW":
        return `/app/workflow/step7/${id}`;
      case "EXPORT":
        return `/app/workflow/step8/${id}`;
      default:
        return `/app/workflow/step1/${id}`;
    }
  };
  const goToProductStep = (e: any, stepName: string) => {
    e.preventDefault();
    switch (stepName) {
      case "BASE_DATA":
        return `/app/workflow/step3/${productId}/${id}`;
      case "ATTRIBUTES":
        return `/app/workflow/step4/${productId}/${id}`;
      case "COPY_WRITING":
        return `/app/workflow/step5/${productId}/${id}`;
      case "TRANSLATION":
        return `/app/workflow/step6/${productId}/${id}`;
      default:
        return `/app/workflow/step1/${id}`;
    }
  };
  const accessUserClientDashboard = () => {
    if (userClientDashboard && !isAdmin && !isCompanyAdmin && !isManager) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    Boolean(id) &&
      WorkflowService.getWorkflowById(id as any)
        .then((response: any) => {
          const glossaryClientObject = { client: response?.client?.name };
          const objectClient = JSON.stringify(glossaryClientObject);
          localStorage.setItem("glossaryClient", objectClient);
          step === "TRANSLATION" &&
            Boolean(funcForFirstLoading) &&
            funcForFirstLoading(response?.language[0]);
          setTabsList(response?.tabs);
          dispatch(workflowSlice.actions.setWorkflowData(response));
          window.scrollTo(0, 0);
        })
        .catch((error) => ErrorToast(error));
  }, [id, location?.pathname]);
  useEffect(() => {
    Boolean(id) &&
      Boolean(productId) &&
      WorkflowService.getWorkflowArrowShow(Number(id), Number(productId))
        .then((response: any) => {
          setArrowArray(response);
        })
        .catch((error) => ErrorToast(error));
  }, [id, productId]);
  useEffect(() => {
    ProfileDetailsService.getProfileDetails()
      .then((data) => {
        dispatch(authSlice.actions.setAuth(data));
      })
      .catch((error) => ErrorToast(error));
  }, []);
  return (
    <Row>
      <Col md={12}>
        <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3">
          {tabsList?.map((stepName: string) => {
            const removeBaseData = !baseData && stepName === "BASE_DATA"; // if we don't have base data and step is 3, don't render
            const removeAttributes = !attributes && stepName === "ATTRIBUTES"; // same logic as above
            if (removeBaseData || removeAttributes) {
              return;
            }
            return (
              <li className="nav-item" key={stepName}>
                <Link
                  className={`nav-link ${
                    step === stepName ? "active" : ""
                  } text-center`}
                  to={handleStepSteper(stepName, Number(id))}
                >
                  {t(`workflow.${stepName}`)}
                  {(isManager || isAdmin || isCompanyAdmin) &&
                    (stepName === "ATTRIBUTES" ||
                      stepName === "BASE_DATA" ||
                      stepName === "COPY_WRITING" ||
                      stepName === "TRANSLATION") &&
                    productId &&
                    arrowArray?.length > 0 &&
                    arrowArray?.includes(stepName) && (
                      <span
                        className="shorcut-workflow"
                        onClick={(e: any) =>
                          navigate(goToProductStep(e, stepName) as string)
                        }
                      >
                        <i
                          className="ri-arrow-right-up-fill"
                          style={{
                            marginLeft: "10px",
                            color:
                              step === stepName && productId
                                ? "#0ab39c"
                                : "#495057",
                          }}
                        />
                      </span>
                    )}
                </Link>
              </li>
            );
          })}
        </ul>
      </Col>
      {[
        "BASE_DATA",
        "ATTRIBUTES",
        "MEDIA",
        "COPY_WRITING",
        "TRANSLATION",
      ].includes(step) &&
        showFilters && (
          // setSelectedProductId
          <Col md={12} className="d-flex justify-content-between mb-2">
            {Boolean(changeFilterHandler) && (
              <div className="d-flex align-items-center">
                <span className="me-1">{t(`workflow.filter`)}:</span>
                <Button
                  variant={`${status === "" ? "" : "outline-"}primary`}
                  onClick={() => changeFilterHandler("status", "", true)}
                  className="d-flex align-items-center"
                  size="sm"
                >
                  {t("global.all")}
                </Button>
                <Button
                  variant={`${status === "finished" ? "" : "outline-"}success`}
                  onClick={() => changeFilterHandler("status", "finished")}
                  className="d-flex mx-2 align-items-center"
                  size="sm"
                >
                  {t("global.finished")}
                </Button>
                <Button
                  variant={`${status === "unfinished" ? "" : "outline-"}danger`}
                  onClick={() => changeFilterHandler("status", "unfinished")}
                  className="d-flex align-items-center"
                  size="sm"
                >
                  {t("global.unfinished")}
                </Button>
                {(assigned === "" || assigned) && (
                  <>
                    <Button
                      variant={`${
                        assigned === "yes" ? "" : "outline-"
                      }warning mx-2`}
                      onClick={() => changeFilterHandler("assigned", "yes")}
                      className="d-flex align-items-center"
                      size="sm"
                    >
                      {t("global.assigned")}
                    </Button>
                    <Button
                      variant={`${assigned === "no" ? "" : "outline-"}info`}
                      onClick={() => changeFilterHandler("assigned", "no")}
                      className="d-flex align-items-center"
                      size="sm"
                    >
                      {t("global.unassigned")}
                    </Button>
                  </>
                )}
                {(isManager || isAdmin || isCompanyAdmin) && (
                  <>
                    <Select
                      key={nanoid()}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          width: "200px",
                        }),
                      }}
                      className="react-select-field ms-2"
                      onChange={(e: any) => handleFilterUser(e)}
                      placeholder={`${t("access_rights.filter_user")}:`}
                      options={userList?.map((user: any) => ({
                        label: `${user?.firstName} ${user?.lastName}`,
                        value: user?.id,
                      }))}
                      defaultValue={
                        step !== "TRANSLATION"
                          ? (pagination as any)?.copywriter > 0
                            ? userList
                                ?.map((user: any) => ({
                                  label: `${user?.firstName} ${user?.lastName}`,
                                  value: user?.id,
                                }))
                                ?.find(
                                  (user: any) =>
                                    user?.value ==
                                    (pagination as any)?.copywriter
                                )
                            : stepPagination?.copywriter > 0
                            ? userList
                                ?.map((user: any) => ({
                                  label: `${user?.firstName} ${user?.lastName}`,
                                  value: user?.id,
                                }))
                                ?.find(
                                  (user: any) =>
                                    user?.value ==
                                    (stepPagination as any)?.copywriter
                                )
                            : null
                          : (pagination as any)?.translator > 0
                          ? userList
                              ?.map((user: any) => ({
                                label: `${user?.firstName} ${user?.lastName}`,
                                value: user?.id,
                              }))
                              ?.find(
                                (user: any) =>
                                  user?.value == (pagination as any)?.translator
                              )
                          : stepPagination?.translator > 0
                          ? userList
                              ?.map((user: any) => ({
                                label: `${user?.firstName} ${user?.lastName}`,
                                value: user?.id,
                              }))
                              ?.find(
                                (user: any) =>
                                  user?.value ==
                                  (stepPagination as any)?.translator
                              )
                          : null
                      }
                      isClearable={true}
                    />
                  </>
                )}
                <h6 className="m-0 p-0 ms-2">{t("workflow.per_page")}:</h6>
                <Select
                  className="react-select-field ms-2"
                  onChange={handlePerPage}
                  placeholder={`${t("workflow.per_page")}:`}
                  options={perPageOptions}
                  defaultValue={
                    stepPagination?.perPage
                      ? {
                          label: stepPagination?.perPage,
                          value: stepPagination?.perPage,
                        }
                      : perPageOptions[0]
                  }
                />
                {step === "TRANSLATION" &&
                  (isManager || isAdmin || isCompanyAdmin) && (
                    <>
                      <h6 className="m-0 p-0 ms-2">
                        {t("workflow.copywriting_status")}:
                      </h6>
                      <Select
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            minWidth: "150px",
                          }),
                        }}
                        className="react-select-field ms-2"
                        onChange={handleFilterCopywritingStatus}
                        placeholder={`${t("workflow.copywriting_status")}:`}
                        options={copywritingStatusOptions}
                        defaultValue={
                          stepPagination?.copywritingStatus
                            ? {
                                label: stepPagination?.copywritingStatus,
                                value: stepPagination?.copywritingStatus,
                              }
                            : copywritingStatusOptions[0]
                        }
                      />
                    </>
                  )}
              </div>
            )}
            <div
              className={`d-flex align-items-center ${
                showMarkAsComplete || showNextButton ? "" : "ms-auto"
              }`}
            >
              <Button
                variant="primary"
                onClick={() => navigate(`/app/products/manage/${id}`)}
                className="d-flex align-items-center"
                size="sm"
              >
                {t("global.manage")}
                <i className="ri-shopping-bag-3-line ms-1" />
              </Button>
            </div>
            {accessUserClientDashboard() && (
              <div className="d-flex align-items-center">
                {showMarkAsComplete && (
                  <Button
                    variant="success"
                    onClick={
                      () => handleMarkAsComplete()
                      // navigate(`/app/workflow/step${step + 1}/${id}`)
                    }
                    className="d-flex align-items-center"
                    disabled={
                      step === "TRANSLATION"
                        ? !isDisabledComplete
                        : precent !== 100
                    }
                    size="sm"
                  >
                    {t("global.markAsComplete")}
                  </Button>
                )}

                {showNextButton && (
                  <Button
                    variant="outline-success"
                    onClick={handleNextProduct}
                    className="ms-2"
                    disabled={precent === 100}
                    size="sm"
                  >
                    {t("global.next")}
                    <i className="ri-arrow-right-line ms-1" />
                  </Button>
                )}
              </div>
            )}
          </Col>
        )}
      <ModalTranslateAll
        show={showTranslateDialog}
        setShow={setShowTranslateDialog}
        translateHandler={translateAll}
      />
      <Col md={12}>
        {accessRights?.includes("workflow_can_translate_all") &&
          step === "TRANSLATION" &&
          showFilters && (
            <div className="d-flex">
              {lightOrDarkMode === "dark" ? (
                <Select
                  className="custom_zindex react-select-field me-1"
                  styles={{
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected ? "#007aff" : "#262a2f",
                      ":hover": {
                        backgroundColor: state.isSelected ? "#007aff" : "black",
                      },
                    }),
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      width: 150,
                      zIndex: showTranslateDialog ? 0 : 9999,
                      ":hover": {
                        backgroundColor: "black",
                      },
                    }),

                    menu: (base) => ({
                      ...base,
                      backgroundColor: "#262a2f",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: showTranslateDialog ? 0 : 9999,
                    }),
                  }}
                  menuPortalTarget={document.body}
                  name="content"
                  theme={themeSelect}
                  placeholder={`${t("formality.select_formality")}`}
                  options={deeplFormality?.map((formality) => ({
                    value: formality,
                    label: getCorrectFormality(formality, t),
                  }))}
                  // key={state?.id}
                  onChange={(e) => {
                    handleSelectSingleFormality(e as any);
                  }}
                />
              ) : (
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      width: 150,
                      zIndex: showTranslateDialog ? 0 : 9999,
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: showTranslateDialog ? 0 : 9999,
                    }),
                  }}
                  menuPortalTarget={document.body}
                  className="custom_zindex react-select-field me-1"
                  name="content"
                  theme={themeSelect}
                  placeholder={`${t("formality.select_formality")}`}
                  options={deeplFormality?.map((formality) => ({
                    value: formality,
                    label: getCorrectFormality(formality, t),
                  }))}
                  // key={state?.id}
                  onChange={(e) => {
                    handleSelectSingleFormality(e as any);
                  }}
                />
              )}

              <button
                onClick={(e) => setShowTranslateDialog(true)}
                className="btn btn-secondary d-flex align-items-center"
              >
                {isLoading ? (
                  <Spinner animation="border" size="sm" role="status" />
                ) : (
                  <span>{t("global.translateAll")}</span>
                )}
              </button>
            </div>
          )}
      </Col>
    </Row>
  );
};
